"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.enData = exports.cnData = void 0;
var cn_1 = require("./cn");
Object.defineProperty(exports, "cnData", { enumerable: true, get: function () { return __importDefault(cn_1).default; } });
var en_1 = require("./en");
Object.defineProperty(exports, "enData", { enumerable: true, get: function () { return __importDefault(en_1).default; } });
//# sourceMappingURL=index.js.map